import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import '@babel/polyfill'
import auth from '@/libs/auth.js'
import { getSettings } from '@/api/http-settings'
import { messages, defaultLocale } from '@/i18n'
import VueI18n from 'vue-i18n'

import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@fortawesome/fontawesome-free/css/all.css'
import axios, { AxiosError, AxiosResponse } from 'axios'
import { post } from '@/api/utils/http-utils'

Vue.use(VueI18n)

const i18n = new VueI18n({
  messages,
  locale: defaultLocale,
  fallbackLocale: defaultLocale
})

Vue.config.productionTip = false

export const basePath: string = ''
export const apiBaseUrl = process.env.NODE_ENV === 'production' ? '/api/v1' : `${process.env.VUE_APP_API_BASE_URL}`

// --------------------------------------------------------------------------------------------------------
// GLOBAL ERROR HANDLING
//
export const errorHandler = (err: any) => {
  let message = err.toString()
  if (err.response) {
    message += ' ' + JSON.stringify(err.response.data)
    console.log('[DEBUG] response', err.response)
  }
  post('/log', message)
    .then((r: AxiosResponse) => {
      if (r.status >= 400) {
        console.log(`[ERROR] could not send POST /log to server. Status: ${r.status}`)
      }
    })
    .catch((e: AxiosError) => {
      console.log('[ERROR] could not send POST /log to server')
    })
}
Vue.config.errorHandler = (err, vm, info) => {
  errorHandler(err.message + '\n' + err.stack)
}
Vue.config.warnHandler = (msg, vm, trace) => {
  errorHandler('[Vue.Warning]' + msg + '\n' + trace)
}
window.onerror = (msg, url, line, col, error) => {
  errorHandler(line + ' ,,, ' + msg + ' ,,, ' + error)
}
window.onunhandledrejection = (event: any) => {
  // handle error here
  // event.promise contains the promise object
  // event.reason contains the reason for the rejection
  errorHandler('rejected, reason: ' + event.reason)
}
axios.interceptors.request.use(
  (config) => {
    if (config.headers.Authorization) {
      return config // do not overwrite get license call with basic auth
    }
    const accessToken = (auth.server != null) ? auth.server.getTokenParsed () : undefined
    if (accessToken) {
      config.headers.Authorization = `Bearer ${ accessToken }`
    }
    return config
  },
  (error) => {
    errorHandler(error + error.response ? error.response.body : '')
    return Promise.reject(error)
  }
)
// ---------------------------------------------------------------------------------------------------------

const start = async () => {
  const settings = await getSettings()
    .catch((e: any) => {
      errorHandler(e)
    })
  console.log('[DEBUG] settings', settings)

  await auth.init(settings)
    .then((authenticated: any) => {
      console.log('[DEBUG] authenticated in main =', authenticated)
      store.dispatch('user/getAllUserProfiles')
    })
    .catch((e: any) => {
      console.log('[ERROR]', e)
    })

  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
}

// tslint:disable-next-line: no-floating-promises
start()
